import React from "react";

export const ChartFallbackPanel = ({ title, error, onRegenerate }) => (
  <div className="chart-fallback-panel" role="alert">
    <div className="fallback-title">⚠ Chart failed to render{title ? `: ${title}` : ""}</div>
    <div className="fallback-body">{error || "Unknown error"}</div>
    {onRegenerate && (
      <button type="button" className="fallback-regenerate" onClick={onRegenerate}>
        Regenerate
      </button>
    )}
  </div>
);
